module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-en5.70375ba.png";